import React, { useEffect, useState } from 'react';
import { isArray } from "underscore";
import { useCartStore } from 'src/hooks/cart';
import System from 'src/helper/system';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import useReduxState from 'src/hooks/useReduxState';
import EditQtyMsg from './EditQtyMsg';
import Constants from 'src/helper/Constants';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { useSystem } from "src/hooks/system";

const PriceTable = (props) => {
    const [linesToDisplay, setLinesToDisplay] = useState();
    const [priceTableExpanded, setPriceTableExpanded] = useState(false)
    const { single_product, hiddenPriceTableMode = false, hiddenMode = false, single_product_pricing_list = [], from = "" } = props;
    const ItemNumber = single_product.ItemNumber;
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [{ }, { get_current_price_by_quantity }, { }] = useProductInventoryPriceStore();
    const [priceSingleLoader] = useReduxState({}, 'priceSingleLoader')
    const [,{ get_quantity_format }] = useSystem();

    const isPLP = linesToDisplay === 2;

    useEffect(() => {
        setLinesToDisplay(!props.linesToDisplay ? 7 : props.linesToDisplay)
    }, [props.linesToDisplay])

    useEffect(() => {
        if (priceTableExpanded) {
            setLinesToDisplay(100)
        }
    }, [priceTableExpanded])

    useEffect(() => {
        // Check and expand price table
        if (CART_BEFORE_TO_SEND_SERVER[ItemNumber] &&
            CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityUpdateToCart &&
            Number(CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityUpdateToCart) &&
            props.linesToDisplay === 3) {
            if (single_product_pricing_list && isArray(single_product_pricing_list) && single_product_pricing_list.length > 3) {
                // get initial 3 pricing quantity array
                let priceArray = single_product_pricing_list.slice(0, 3).map((x) => x.quantity)
                if (priceArray && Array.isArray(priceArray) && priceArray.length > 0) {
                    let priceRangeExist = CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityUpdateToCart <= priceArray[priceArray.length - 1];
                    if (!priceRangeExist) {
                        setLinesToDisplay(100)
                    }
                }
            }
        }
    }, [single_product_pricing_list, CART_BEFORE_TO_SEND_SERVER[ItemNumber]]);

    const getLinesToDisplayProp = () => {
        return !props.linesToDisplay ? 7 : props.linesToDisplay;
    };
    const getQuantityAddToCart = () => {
        let q = CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber] || false
        if (q.quantityUpdateToCart) {
            return q.quantityUpdateToCart;
        }
        return 0
    };

    const getBoldClass = (single_price, current_index) => {
        const selectedQty = getQuantityAddToCart()
        let d = false
        const _price = get_current_price_by_quantity(single_product_pricing_list, selectedQty);

        if (_price.quantity === single_price.quantity) {
            d = true
        }
        return d ? 'font-bold' : ' ';
    };

    function checkHandShake() {
        return System.checkIsCustomerPrice(single_product_pricing_list)
    }

    return (
        <div style={{ display: hiddenMode ? 'none' : 'block', }}>

            {priceSingleLoader[single_product.ItemNumber]?.status ?
                <div className="d-flex justify-content-center">
                    <AxiosIndicatorRunTimeLoader inline={true} />
                </div> :
                <>
                    {checkHandShake() &&
                        <div className="blue-head cpn-box">
                            <span className="text-nowrap">Customer Specific Pricing</span>
                            <span className="fa fa-handshake-o" />
                        </div>
                    }

                    {(single_product_pricing_list && single_product_pricing_list.length && !hiddenPriceTableMode) ?
                        <div className="price-table-list">

                            {single_product_pricing_list.map((v, i) => (
                                <div className={'bs5 row mx-0 ' + getBoldClass(v, i)} key={i} style={
                                    {
                                        display: isPLP ? ((i == 0 || i === (single_product_pricing_list.length - 1)) ? '' : 'none') : ((i + 1) > linesToDisplay ? 'none' : '')
                                    }
                                }>
                                    <div className="ps-0 col-4 font-12"
                                        style={{ visibility: (!v.quantity || isNaN(v.quantity) || Number(v.quantity) <= 0 ? 'hidden' : 'visible') }}>
                                           <span>{get_quantity_format(v.quantity)+ '+'}</span>
                                    </div>
                                    <div className="pe-0 col-8 text-end font-12">
                                        <span>{System.getFormatNumber({ amount: Number(v.marketPrice), currency: v.currency })}</span>
                                    </div>
                                </div>
                            ))

                            }

                        </div>
                        : null
                    }
                </>
            }
            <a className='text-blue2 d-flex mt-1' href={void (0)} style={{ paddingLeft: '0' }} onClick={() => {
                if (linesToDisplay === getLinesToDisplayProp()) {
                    setLinesToDisplay(100)
                    setPriceTableExpanded(true)
                } else {
                    setLinesToDisplay(getLinesToDisplayProp())
                }
            }
            }>
                {single_product_pricing_list.length > (getLinesToDisplayProp() - 1) &&
                    <>
                        {linesToDisplay < single_product_pricing_list.length && !hiddenPriceTableMode &&
                            <>
                                <span className='font-bold font-12'>More Pricing </span>
                                <i className="fa fa-angle-down font-bold font-18 ms-1"></i>
                            </>
                        }
                        {linesToDisplay !== getLinesToDisplayProp() &&
                            <>
                                <span className='font-bold font-12'>Less Pricing </span>
                                <i className="fa fa-angle-up font-bold font-16 ms-1"></i>
                            </>
                        }
                    </>
                }
            </a>

            {from !== Constants.systemModules.Quote &&  <EditQtyMsg single_product_pricing_list={single_product_pricing_list} />}
        </div>
    );
};

export default PriceTable;